import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import {
    themes,
    plugin as VuetifyToolbox,
} from '@jobstairs/vuetify-toolbox/src';
import '@fortawesome/fontawesome-free/css/all.css';

import HelpIcon from '../assets/icons/help.svg?vue-component';
import InsertChartIcon from '../assets/icons/insert_chart.svg?vue-component';
import LeaderboardIcon from '../assets/icons/leaderboard.svg?vue-component';
import LockIcon from '../assets/icon-betterads-lock.svg?vue-component';
import LogoutIcon from '../assets/icons/logout.svg?vue-component';
import PersonIcon from '../assets/icon-betterads-person.svg?vue-component';
import TrendingDownIcon from '../assets/icon-betterads-trending-down.svg?vue-component';
import TrendingFlatIcon from '../assets/icon-betterads-trending-flat.svg?vue-component';
import TrendingUpIcon from '../assets/icon-betterads-trending-up.svg?vue-component';
import UploadFileIcon from '../assets/icon-betterads-upload-file.svg?vue-component';
import DashboardIcon from '../assets/icons/dashboard.svg?vue-component';
import ExpandLessIcon from '../assets/icon-betterads-expand-less.svg?vue-component';
import ExpandMoreIcon from '../assets/icon-betterads-expand-more.svg?vue-component';
import CheckMarkIcon from '../assets/icon-betterads-check-mark.svg?vue-component';
import ExclamationMarkIcon from '../assets/icon-betterads-exclamation-mark.svg?vue-component';
import QuestionMarkIcon from '../assets/icon-betterads-question-mark.svg?vue-component';
import InfoIcon from '../assets/icon-betterads-info.svg?vue-component';
import WorkIcon from '../assets/icons/work.svg?vue-component';
import GroupWorkIcon from '../assets/icons/group-work.svg?vue-component';
import ComputerIcon from '../assets/icons/computer.svg?vue-component';
import AwesomeIcon from '../assets/icon-betterads-awesome.svg?vue-component';
import BackIcon from '../assets/icon-betterads-back.svg?vue-component';
import ErrorIcon from '../assets/icons/error.svg?vue-component';
import CloseIcon from '../assets/icons/close.svg?vue-component';
import ThumbUpIcon from '../assets/icons/thumb-up.svg?vue-component';
import ThumbDownIcon from '../assets/icons/thumb-down.svg?vue-component';
import ThumbUpIconDisabled from '../assets/icons/thumb-up-disabled.svg?vue-component';
import ThumbDownIconDisabled from '../assets/icons/thumb-down-disabled.svg?vue-component';
import ChatbotIcon from '../assets/icon-betterads-chatbot.svg?vue-component';

// TODO remove icons then components have been adjusted.
import LightningIcon from '../assets/icon-betterads-quickcheck-solo.svg?vue-component';
import RobbyIcon from '../assets/icon-betterads-robo-neg.svg?vue-component';
import RadarIcon from '../assets/icon-betterads-scoring-solo.svg?vue-component';
import CompassIcon from '../assets/icon-betterads-company-analysis.svg?vue-component';
import ArrowDownIcon from '../assets/icon-betterads-arrow-down.svg?vue-component';
import TrophyIcon from '../assets/icon-betterads-trophy.svg?vue-component';
import FlipIcon from '../assets/icon-betterads-flip.svg?vue-component';
import BoltIcon from '../assets/icon-betterads-bolt.svg?vue-component';
import PersonPlayingIcon from '../assets/icons/person-playing.svg?vue-component';
import PersonVerifiedIcon from '../assets/icons/person-verified.svg?vue-component';
import SchoolIcon from '../assets/icons/school.svg?vue-component';
import SchoolStarIcon from '../assets/icons/school-star.svg?vue-component';
import StarIcon from '../assets/icons/star.svg?vue-component';
import VerifiedIcon from '../assets/icons/verified.svg?vue-component';

Vue.use(Vuetify);
Vue.use(VuetifyToolbox);

let betterAdsThemes = themes;
betterAdsThemes.light.primary = '#0055D5';
betterAdsThemes.light.onPrimary = '#ffffff';
betterAdsThemes.light.primaryContainer = '#DAE1FF';
betterAdsThemes.light.onPrimaryContainer = '#001849';

betterAdsThemes.light.secondary = '#585E71';
betterAdsThemes.light.onSecondary = '#ffffff';
betterAdsThemes.light.secondaryContainer = '#DDE2F9';
betterAdsThemes.light.onSecondaryContainer = '#151B2C';

betterAdsThemes.light.tertiary = '#8A5100';
betterAdsThemes.light.onTertiary = '#ffffff';
betterAdsThemes.light.tertiaryContainer = '#FFDCBD';
betterAdsThemes.light.onTertiaryContainer = '#2C1600';

betterAdsThemes.light.error = '#BA1A1A';
betterAdsThemes.light.onError = '#ffffff';
betterAdsThemes.light.errorContainer = '#FFDAD6';
betterAdsThemes.light.onErrorContainer = '#410002';

betterAdsThemes.light.background = '#F2F2F2';
betterAdsThemes.light.onBackground = '#1B1B1F';
betterAdsThemes.light.backgroundContainer = '#ffffff';
betterAdsThemes.light.onBackgroundContainer = '#1B1B1F';

betterAdsThemes.light.outline = '#757680';
betterAdsThemes.light.surfaceVariant = '#E1E2EC';
betterAdsThemes.light.onSurfaceVariant = '#45464F';
betterAdsThemes.light.frontSureface = '#e0eafa';

// TODO remove colours when the components have been adjusted.
betterAdsThemes.light.green = '#48A348';
betterAdsThemes.light['dark-green'] = '#388038';
betterAdsThemes.light.orange = '#C7811F';
betterAdsThemes.light.red = '#C41845';
betterAdsThemes.light['dark-red'] = '#831A35';
betterAdsThemes.dark = { red: '#C41845' };

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: betterAdsThemes,
    },
    icons: {
        iconfont: 'fa',
        values: {
            bolt: {
                component: BoltIcon,
            },
            help: {
                component: HelpIcon,
            },
            insertChart: {
                component: InsertChartIcon,
            },
            leaderboard: {
                component: LeaderboardIcon,
            },
            lock: {
                component: LockIcon,
            },
            logout: {
                component: LogoutIcon,
            },
            person: {
                component: PersonIcon,
            },
            trendingDown: {
                component: TrendingDownIcon,
            },
            trendingFlat: {
                component: TrendingFlatIcon,
            },
            trendingUp: {
                component: TrendingUpIcon,
            },
            upload: {
                component: UploadFileIcon,
            },
            dashboard: {
                component: DashboardIcon,
            },
            expandLess: {
                component: ExpandLessIcon,
            },
            expandMore: {
                component: ExpandMoreIcon,
            },
            checkMark: {
                component: CheckMarkIcon,
            },
            exclamationMark: {
                component: ExclamationMarkIcon,
            },
            questionMark: {
                component: QuestionMarkIcon,
            },
            info: {
                component: InfoIcon,
            },
            awesome: {
                component: AwesomeIcon,
            },
            back: {
                component: BackIcon,
            },
            error: {
                component: ErrorIcon,
            },
            close: {
                component: CloseIcon,
            },
            thumbUp: {
                component: ThumbUpIcon,
            },
            thumbDown: {
                component: ThumbDownIcon,
            },
            thumbUpDisabled: {
                component: ThumbUpIconDisabled,
            },
            thumbDownDisabled: {
                component: ThumbDownIconDisabled,
            },
            chatbot: {
                component: ChatbotIcon,
            },

            // TODO remove then components are adjusted.
            lightning: {
                component: LightningIcon,
            },
            robby: {
                component: RobbyIcon,
            },
            radar: {
                component: RadarIcon,
            },
            compass: {
                component: CompassIcon,
            },
            arrowDown: {
                component: ArrowDownIcon,
            },
            trophy: {
                component: TrophyIcon,
            },
            flip: {
                component: FlipIcon,
            },
            personPlaying: {
                component: PersonPlayingIcon,
            },
            personVerified: {
                component: PersonVerifiedIcon,
            },
            school: {
                component: SchoolIcon,
            },
            schoolStar: {
                component: SchoolStarIcon,
            },
            star: {
                component: StarIcon,
            },
            verified: {
                component: VerifiedIcon,
            },
            computer: {
                component: ComputerIcon,
            },
            work: {
                component: WorkIcon,
            },
            groupWork: {
                component: GroupWorkIcon,
            },
        },
    },
});
